interface BrandLogoProps {
  variant?: 'light' | 'dark' | 'auto';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Brand logo component using the official lykbl™ logo.
 * - light: Standard logo (for dark backgrounds)
 * - dark: Inverted logo (for light backgrounds)
 * - auto: follows the active lykbl theme via --lk-logo-filter
 */
export default function BrandLogo({ variant = 'light', className = '', size = 'md' }: BrandLogoProps) {
  // Size configurations
  const sizeMap = {
    sm: { height: '24px', width: 'auto' },
    md: { height: '32px', width: 'auto' },
    lg: { height: '48px', width: 'auto' },
  };
  
  const { height, width } = sizeMap[size];
  
  return (
    <div className={`flex items-center gap-1 ${className}`} aria-label="lykbl™">
      <img 
        src="/lykbl_logo.png" 
        alt="lykbl"
        style={{ 
          height,
          width,
          // If variant is dark (for light bg), invert colors.
          // Since the logo is white with shadow, inverting might look odd with shadow,
          // but it's the standard way to flip a white logo to dark without a separate asset.
          filter:
            variant === 'auto'
              ? 'var(--lk-logo-filter)'
              : variant === 'dark'
                ? 'invert(1) hue-rotate(180deg)'
                : 'none',
          objectFit: 'contain'
        }}
        className="select-none"
      />
      <sup
        className={`text-[8px] font-medium ${
          variant === 'light' ? 'text-white/50' : variant === 'auto' ? 'text-lk-ink/50' : 'text-ink/50'
        }`}
        style={{ marginTop: '-8px' }}
      >
        ™
      </sup>
    </div>
  );
}
